import firebase from "firebase/app";
import "firebase/analytics";
import { BrowserRouter as Router, Route } from "react-router-dom";

import Home from "./Home";
import Footer from "./Footer";
import Navbar from "./Navbar";
import ThreadView from "./ThreadView";
import ToU from "./ToU";
import Help from "./Help";

if (!firebase.apps.length) {
  firebase.initializeApp({
    apiKey: "AIzaSyDPnBEo5dYRRLske_p5j1oQdl0grvlm0SE",
    authDomain: "thread2blog.firebaseapp.com",
    projectId: "thread2blog",
    storageBucket: "thread2blog.appspot.com",
    messagingSenderId: "733518154570",
    appId: "1:733518154570:web:1511f1f3b05483d6400fb3",
    measurementId: "G-VZSMX1KEY1",
  });
} else {
  firebase.app(); // if already initialized, use that one
}

if (process.env.NODE_ENV === "production") {
  firebase.analytics();
}

function App() {
  return (
    <Router>
      <div className="bg-gray-100">
        <Navbar />

        <Route exact path="/" component={Home} />
        <Route path="/thread/:threadId" component={ThreadView} />

        <Route path="/help" component={Help} />
        <Route path="/tou" component={ToU} />

        <Footer />
      </div>
    </Router>
  );
}

export default App;
